export const FiatCurrency = {
  usd: "usd",
};

export const FiatSymbol = {
  usd: "$",
};

export const SUPPORTED_FIAT = [FiatCurrency.usd];
